<template>
  <div :class="ns.b('group')">
    <template v-for="(vnode, index) in showVNodes" :key="index">
      <component :is="vnode" />
    </template>
    <JdAvatarRetracted
      v-show="hasMaxCountLimit && restCount > 0"
      :show-tooltip="showTooltip"
      :count="restCount"
    >
      <slot v-if="$slots.tooltip" name="tooltip" :nodeList="dataList" />
      <template v-else>
        <template v-for="(vnode, index) in restVNodes" :key="index">
          <component :is="vnode" />
        </template>
      </template>
    </JdAvatarRetracted>
  </div>
</template>

<script lang="ts" setup>
import { computed, useSlots, toRef, provide, reactive } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'
import { avatarGroupProps } from './avatar-group.type'
import { avatarGroupContextKey } from './constants'
import JdAvatarRetracted from './avatar-retracted.vue'

defineOptions({
  name: 'JdAvatarGroup',
})

const props = defineProps(avatarGroupProps)
const slots = useSlots()
const ns = useNamespace('avatar')

//tooltipSlots插槽存在不需要往覆盖子组件size
//Provide context to child components
const tooltipSlots = slots.tooltip?.() || []
if (tooltipSlots.length === 0) {
  provide(
    avatarGroupContextKey,
    reactive({
      size: toRef(props, 'size'),
    })
  )
}

const dataList = computed(() => {
  return {
    all: slots.default?.() || [],
    rest: restVNodes.value,
  }
})
// Computed properties
const hasMaxCountLimit = computed(() => !!Number(props.maxCount))

const showVNodes = computed(() => {
  const defaultSlots = slots.default?.() || []
  if (hasMaxCountLimit.value) {
    return defaultSlots.slice(0, Number(props.maxCount))
  }
  return defaultSlots
})
const restCount = computed(() => {
  return (slots.default?.().length || 0) - (Number(props.maxCount) || 0)
})

const restVNodes = computed(() => {
  return hasMaxCountLimit.value
    ? slots.default?.().slice(Number(props.maxCount))
    : []
})
</script>
